<template>
  <div class="container">
    <homepage-filter
      job-search-page
      :categories-prop="filterFields.categories"
      :locations-prop="filterFields.locations"
      @category="val => $set(filterFields, 'categories', val)"
      @location="val => $set(filterFields, 'locations', val)"
    />
    <div
      id="jobseeker-list"
      class="columns is-multiline my-2 has-padding-left-10-mobile has-padding-right-10-mobile"
    >
      <div class="column is-12">
        <div class="is-pulled-left">
          {{
            $t('foundJobseekerMatches', [
              get($store.state.collection.collectionResponses, [
                'jobSeekerSearchCollection',
                'count'
              ]) || 0
            ])
          }}
        </div>
      </div>
      <client-only>
        <div class="column is-4">
          <div class="card">
            <div>
              <div class="card-header-title is-size-5">
                <span>{{ $t('Refine your search') }}</span>
                <a
                  v-if="showClearSearch"
                  class="is-size-7 has-margin-left-auto"
                  @click="clearSearch"
                  >{{ $t('Clear Search') }}</a
                >
              </div>

              <div
                class="pointer card-header-title"
                @click="
                  expansionController.jobPreference = !expansionController.jobPreference
                "
              >
                {{ $t('Job Preference') }}
              </div>
              <transition name="slide-fade card">
                <div v-if="expansionController.jobPreference">
                  <div class="columns card-content is-multiline">
                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-science')]"
                          ></vue-icon-base>
                          {{ $t('skills') }}
                        </label>
                        <div>
                          <vue-auto-complete
                            v-model="filterFields.skills"
                            extra-input-class="is-small"
                            item-text="name"
                            item-value="slug"
                            endpoint="/api/v1/common/skills/"
                            allow-multiple
                          ></vue-auto-complete>
                        </div>
                      </div>
                    </div>

                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-clock')]"
                          ></vue-icon-base>
                          {{ $t('Preferred Shift') }}
                        </label>
                        <div>
                          <auto-complete
                            v-model="filterFields.preferred_shift"
                            extra-input-class="is-small"
                            :items="$options.preferredShitChoices"
                            item-text="name"
                            item-value="value"
                          ></auto-complete>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-money-bill')]"
                          ></vue-icon-base>
                          {{ $t('Expected Salary') }}
                        </label>
                        <div class="control pl-5 is-size-8 has-text-grey">
                          <label class="radio">
                            <input
                              v-model="salaryOptions"
                              value="firstOption"
                              :checked="salaryOptions === 'firstOption'"
                              type="radio"
                              name="salary"
                              @change="getSalaryFilter(0, 15000)"
                            />
                            {{ `${$t('Rs')}. ${$t('15000')} ${$t('or less')}` }}
                          </label>
                          <br />
                          <label class="radio">
                            <input
                              v-model="salaryOptions"
                              value="secondOption"
                              :checked="salaryOptions === 'secondOption'"
                              type="radio"
                              name="salary"
                              @change="getSalaryFilter(15001, 25000)"
                            />
                            {{ $t('Rs') }}. {{ $t('15001') }} - {{ $t('Rs') }}.
                            {{ $t('25000') }}
                          </label>
                          <br />
                          <label class="radio">
                            <input
                              v-model="salaryOptions"
                              value="thirdOption"
                              type="radio"
                              :checked="salaryOptions === 'thirdOption'"
                              name="salary"
                              @change="getSalaryFilter(25001, 35000)"
                            />
                            {{ $t('Rs') }}. {{ $t('25001') }} - {{ $t('Rs') }}.
                            {{ $t('35000') }}
                          </label>
                          <br />
                          <label class="radio">
                            <input
                              v-model="salaryOptions"
                              type="radio"
                              value="fourthOption"
                              :checked="salaryOptions === 'fourthOption'"
                              name="salary"
                              @change="getSalaryFilter(35001, 50000)"
                            />
                            {{ $t('Rs') }}. {{ $t('35001') }} - {{ $t('Rs') }}.
                            {{ $t('50000') }}
                          </label>
                          <br />
                          <label class="radio">
                            <input
                              v-model="salaryOptions"
                              value="fifthOption"
                              type="radio"
                              :checked="salaryOptions === 'fifthOption'"
                              name="salary"
                              @change="getSalaryFilter(50001, '')"
                            />
                            {{ $t('Rs') }}. {{ $t('50000') }}+
                          </label>
                          <br />
                          <div
                            class="columns is-multiline is-mobile is-vcentered is-desktop"
                          >
                            <div class="column is-1">
                              <label class="radio">
                                <input
                                  v-model="salaryOptions"
                                  value="customOption"
                                  type="radio"
                                  name="salary"
                              /></label>
                            </div>
                            <div class="column is-1 px-0">{{ $t('Rs') }}.</div>
                            <div class="column is-4 pl-0">
                              <input
                                v-model="minimumSalary"
                                min="0"
                                :disabled="salaryOptions !== 'customOption'"
                                :placeholder="$t('Minimum')"
                                type="number"
                                class="input is-small"
                              />
                            </div>
                            <div class="column is-1 px-0">to</div>
                            <div class="column is-4 pl-0">
                              <input
                                v-model="maximumSalary"
                                min="0"
                                :disabled="salaryOptions !== 'customOption'"
                                :placeholder="$t('Maximum')"
                                type="number"
                                class="input is-small"
                              />
                            </div>
                            <div class="column is-11 has-text-right py-0">
                              <button
                                v-if="salaryOptions === 'customOption'"
                                class="button is-size-7 has-text-grey"
                                :disabled="!maximumSalary && !minimumSalary"
                                @click="
                                  getSalaryFilter(minimumSalary, maximumSalary)
                                "
                              >
                                {{ $t('Apply Filter') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-list-ul')]"
                          ></vue-icon-base>
                          {{ $t('Job Type') }}
                        </label>
                        <div>
                          <auto-complete
                            v-model="filterFields.available_for"
                            extra-input-class="is-small"
                            :items="$options.availableForChoices"
                            item-text="name"
                            item-value="value"
                          ></auto-complete>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-sitemap')]"
                          ></vue-icon-base>
                          {{ $t('Job Level') }}
                        </label>
                        <div>
                          <auto-complete
                            v-model="filterFields.job_level"
                            extra-input-class="is-small"
                            :items="$options.jobLevelChoices"
                            item-text="name"
                            item-value="value"
                          ></auto-complete>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>

              <div
                class="pointer card-header-title"
                @click="
                  expansionController.educationAndExperience = !expansionController.educationAndExperience
                "
              >
                {{ $t('Education And Work Experience') }}
              </div>
              <transition name="slide-fade">
                <div v-if="expansionController.educationAndExperience">
                  <div class="columns card-content is-multiline">
                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-book-open')]"
                          ></vue-icon-base>
                          {{ $t('Education') }}
                        </label>
                        <div>
                          <vue-auto-complete
                            v-model="filterFields.education_degree"
                            extra-input-class="is-small"
                            item-text="name"
                            item-value="id"
                            endpoint="/api/v1/common/education-degrees/"
                          ></vue-auto-complete>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-briefcase')]"
                          ></vue-icon-base>
                          {{ $t('Work Experience') }}
                        </label>
                        <div>
                          <auto-complete
                            v-model="filterFields.experience"
                            extra-input-class="is-small"
                            :items="$options.workExperienceChoices"
                            item-text="name"
                            item-value="value"
                          ></auto-complete>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>

              <div
                class="pointer card-header-title"
                @click="
                  expansionController.otherInfo = !expansionController.otherInfo
                "
              >
                {{ $t('Other Information') }}
              </div>
              <transition name="slide-fade">
                <div v-if="expansionController.otherInfo">
                  <div class="columns card-content is-multiline">
                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-mars')]"
                          ></vue-icon-base>
                          {{ $t('Gender') }}
                        </label>
                        <div>
                          <auto-complete
                            v-model="filterFields.gender"
                            extra-input-class="is-small"
                            :items="[
                              ...$options.genderChoices,
                              { name: 'No Preference', value: '' }
                            ]"
                            item-text="name"
                            item-value="value"
                          ></auto-complete>
                        </div>
                      </div>
                    </div>

                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-calender')]"
                          ></vue-icon-base>
                          {{ $t('Age') }}
                        </label>
                        <div class="control pl-5 is-size-8 has-text-grey">
                          <label class="radio">
                            <input
                              v-model="ageOptions"
                              value="firstOption"
                              :checked="ageOptions === 'firstOption'"
                              type="radio"
                              name="age"
                              @change="getAgeFilter(16, 25)"
                            />
                            {{ `${$t('16-25')} ${$t('Year')}` }}
                          </label>
                          <br />
                          <label class="radio">
                            <input
                              v-model="ageOptions"
                              value="secondOption"
                              :checked="ageOptions === 'secondOption'"
                              type="radio"
                              name="age"
                              @change="getAgeFilter(26, 35)"
                            />
                            {{ `${$t('26-35')} ${$t('Year')}` }}
                          </label>
                          <br />
                          <label class="radio">
                            <input
                              v-model="ageOptions"
                              value="thirdOption"
                              type="radio"
                              :checked="ageOptions === 'thirdOption'"
                              name="age"
                              @change="getAgeFilter(36, 50)"
                            />
                            {{ `${$t('36-50')} ${$t('Year')}` }}
                          </label>
                          <br />
                          <label class="radio">
                            <input
                              v-model="ageOptions"
                              type="radio"
                              value="fourthOption"
                              :checked="ageOptions === 'fourthOption'"
                              name="age"
                              @change="getAgeFilter(51, 0)"
                            />

                            {{ `${$t('Above-50')} ${$t('Year')}` }} +
                          </label>
                          <br />
                          <div
                            class="columns is-multiline is-mobile is-vcentered is-desktop"
                          >
                            <div class="column is-1">
                              <label class="radio">
                                <input
                                  v-model="ageOptions"
                                  value="customOption"
                                  type="radio"
                                  name="age"
                              /></label>
                            </div>
                            <div class="column is-4 pr-0">
                              <input
                                v-model="minimumAge"
                                min="16"
                                :disabled="ageOptions !== 'customOption'"
                                :placeholder="$t('Minimum')"
                                type="number"
                                class="input is-small"
                              />
                            </div>
                            <div class="column is-1 px-0 has-text-centered">
                              to
                            </div>
                            <div class="column is-4 pl-0">
                              <input
                                v-model="maximumAge"
                                min="16"
                                :disabled="ageOptions !== 'customOption'"
                                :placeholder="$t('Maximum')"
                                type="number"
                                class="input is-small"
                              />
                            </div>
                            <div class="column is-10 has-text-right py-0">
                              <button
                                v-if="ageOptions === 'customOption'"
                                class="button is-size-7 has-text-grey"
                                :disabled="!maximumAge && !minimumAge"
                                @click="getAgeFilter(minimumAge, maximumAge)"
                              >
                                {{ $t('Apply Filter') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12 px-2">
                      <div class="field">
                        <label class="label is-size-6 has-text-grey">
                          <vue-icon-base
                            height="16"
                            width="16"
                            :path="$options.icons[$kc('uni-bus-alt')]"
                          ></vue-icon-base>
                          {{ $t('Has Two Wheeler') }}
                          <vue-switch v-model="filterFields.own_two_wheeler" />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </client-only>
      <div class="column is-8 mt-3">
        <div v-if="jobsCollections.length && !loading">
          <jobseeker-preview
            :active-jobs="jobsCollections"
            class="mb-3"
            collection-name="jobSeekerSearchCollection"
            @refresh="getData()"
          ></jobseeker-preview>
          <pagination
            v-model="paginationController.page"
            collection-name="jobSeekerSearchCollection"
            :page-size="paginationController.itemsPerPage"
            @scroll="scrollToTop"
          ></pagination>
        </div>
        <div v-else class="column">
          <vue-no-data :loading="loading"></vue-no-data>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomepageFilter from '@/components/Job/HomepageFilter'
import JobseekerPreview from '@/components/Organization/Profile/EmployeeOverview/JobseekerPreview'
import Pagination from '@/components/Commons/Pagination'
import VueAutoComplete from '@/components/Commons/VueAutoComplete'
import AutoComplete from '@/components/Commons/AutoComplete'
// import RangeSlider from '@/components/Commons/RangeSlider'
import VueSwitch from '@/components/Commons/VueSwitch'
import VueIconBase from '@/components/Commons/VueIconBase'

import {
  uniStoreAlt,
  uniListUl,
  uniListUiAlt,
  uniScience,
  uniClock,
  uniMoneyBill,
  uniSitemap,
  uniBookOpen,
  uniBriefcase,
  uniCalender,
  uniBusAlt,
  uniMars
} from '@/helpers/icons'
import { getResouceUrl } from '@/helpers/utils/searchUtils'
import {
  availableForChoices,
  genderChoices,
  jobLevelChoices,
  workExperienceChoices
} from '@/helpers/constants/jobseeker'
import { preferredShitChoices } from '@/helpers/constants/common'
import VueNoData from '@/components/Commons/VueNoData'
import { scrollToContent } from '@/helpers/utils/common.js'

export default {
  preferredShitChoices,
  jobLevelChoices,
  genderChoices,
  workExperienceChoices,
  availableForChoices,
  scrollToContent,
  icons: {
    uniStoreAlt,
    uniListUl,
    uniListUiAlt,
    uniScience,
    uniClock,
    uniMoneyBill,
    uniSitemap,
    uniBookOpen,
    uniBriefcase,
    uniCalender,
    uniBusAlt,
    uniMars
  },
  components: {
    VueNoData,
    HomepageFilter,
    JobseekerPreview,
    Pagination,
    VueAutoComplete,
    AutoComplete,
    // RangeSlider,
    VueSwitch,
    VueIconBase
  },
  async asyncData({ params, store, $axios, route }) {
    const itemsPerPage = 7
    const paginationFields = {
      limit: itemsPerPage
    }
    const filterFields = Object.assign({}, route.query)
    const contentUrl = '/api/v1/jobseekers/search/'
    const resourceUrl = getResouceUrl(contentUrl, {
      ...paginationFields,
      ...filterFields
    })
    const { data } = await $axios.get(resourceUrl)

    store.commit('collection/setCollectionData', [
      'jobSeekerSearchCollection',
      data
    ])

    store.commit('collection/changeHomePageFilterFor', 'job-seeker')

    const homepageJobsUrl = '/api/v1/jobseekers/home-page-jobseekers/'

    const homePageJobsData = await $axios.get(homepageJobsUrl)

    store.commit('collection/setCollectionData', [
      'homePageJobs',
      homePageJobsData.data
    ])

    return {
      contentUrl,
      filterFields,
      paginationFields,
      paginationController: {
        page: 1,
        itemsPerPage
      },
      totalCount: data.count
    }
  },
  data() {
    return {
      loading: false,
      expansionController: {
        jobPreference: true,
        educationAndExperience: true,
        otherInfo: true
      },
      minimumSalary: '',
      maximumSalary: '',
      salaryOptions: '',
      minimumAge: '',
      maximumAge: '',
      ageOptions: ''
    }
  },
  computed: {
    jobsCollections() {
      return this.$store.state.collection.collectionResponses
        .jobSeekerSearchCollection.results
    },
    showClearSearch() {
      const filterFieldsCopy = { ...this.filterFields }
      delete filterFieldsCopy.search
      delete filterFieldsCopy.limit
      return Object.values(filterFieldsCopy).some(value => !!value)
    }
  },
  watch: {
    'paginationController.page': {
      handler(newVal) {
        this.$set(
          this.paginationFields,
          'offset',
          this.paginationController.itemsPerPage * (newVal - 1)
        )

        this.$set(
          this.paginationFields,
          'limit',
          this.paginationController.itemsPerPage
        )

        this.getData()
      }
    },
    '$route.query': {
      handler(newVal) {
        this.filterFields = Object.assign(this.filterFields, this.$route.query)
      },
      deep: true
    },
    paginationFields: {
      handler() {
        window.history.pushState(
          'page2',
          'Title',
          getResouceUrl('', { ...this.filterFields, ...this.paginationFields })
        )
        this.getData()
      },
      deep: true
    },
    filterFields: {
      handler() {
        window.history.pushState(
          'page2',
          'Title',
          getResouceUrl('', { ...this.filterFields, ...this.paginationFields })
        )
        this.scrollToTop()
        this.paginationController.page = 1
        this.getData()
      },
      deep: true
    },
    salaryOptions(val) {
      if (val !== 'customOption') {
        this.maximumSalary = ''
        this.minimumSalary = ''
      }
    },
    ageOptions(val) {
      if (val !== 'customOption') {
        this.maximumAge = ''
        this.minimumAge = ''
      }
    }
  },
  methods: {
    async getData() {
      this.loading = true
      const filter = { ...this.filterFields, ...this.paginationFields }
      const resourceUrl = getResouceUrl(this.contentUrl, filter)
      const { data } = await this.$axios.get(resourceUrl)
      this.$store.commit('collection/setCollectionData', [
        'jobSeekerSearchCollection',
        data
      ])
      this.loading = false
    },
    getSalaryFilter(min, max) {
      this.filterFields.salary_min = min
      this.filterFields.salary_max = max
      window.history.pushState(
        'page2',
        'Title',
        getResouceUrl('', { ...this.filterFields, ...this.paginationFields })
      )
      this.scrollToTop()
      this.paginationController.page = 1
      this.getData()
    },
    scrollToTop() {
      if (!this.loading) {
        setTimeout(() => {
          this.$options.scrollToContent('jobseeker-list')
        }, 200)
      }
    },
    getAgeFilter(min, max) {
      this.filterFields.age_min = min
      this.filterFields.age_max = max
      window.history.pushState(
        'page2',
        'Title',
        getResouceUrl('', { ...this.filterFields, ...this.paginationFields })
      )
      this.scrollToTop()
      this.paginationController.page = 1
      this.getData()
    },
    clearSearch() {
      this.filterFields = {}
      this.salaryOptions = ''
      this.minimumSalary = ''
      this.maximumSalary = ''
      this.ageOptions = ''
      this.minimumAge = ''
      this.maximumAge = ''
    }
  }
}
</script>
<style scoped>
.is-size-8 {
  font-size: 0.85rem;
}
</style>
